// extracted by css-extract-rspack-plugin
export default {"list":"_4feaa49d","image":"_f06619b8"};